<template>
  <div>
    <div class="diet-calculater">
      <div class="image-content">
        <img
          class="image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/43534af78d5a4bcda3faab71b978cf25.png"
          alt=""
        />
      </div>
      <div class="bottom">
        <div class="btn" @click="bindClick"
          >生成我的精准饮食方案<span class="flag">NEW</span></div
        >
        <div class="text"
          >* 计算依据：《中国居民膳食指南》《中国食物成分表》</div
        >
        <img
          class="logo"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
          alt=""
        />
      </div>
    </div>
    <div></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loaded: false
    }
  },
  methods: {
    bindClick() {
      this.$router.replace('/diet-calculator/question')
    }
  }
}
</script>
<style lang="scss" scoped>
.diet-calculater {
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  text-align: center;
  background-color: #fff;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5cf00127ae5a602fb821d39ef94090f1.png');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center top;
  overflow: hidden;

  .image-content {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    margin-top: 11vh;
    margin-bottom: 6vh;
    padding: 0px 32px 0px 21px;

    .image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .bottom {
    display: flex;
    align-items: center;
    flex-direction: column;

    .btn {
      position: relative;
      width: 273px;
      height: 42px;
      line-height: 42px;
      border-radius: 21px;
      border: 2px solid #6236ff;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #6236ff;
      letter-spacing: 1px;
      margin-bottom: 1.2vh;

      .flag {
        position: absolute;
        transform: translate(0%, -50%);
        right: 0px;
        top: 0px;
        padding: 0px 10px;
        height: 30px;
        line-height: 30px;
        border-radius: 15px 15px 15px 0px;
        background: #7b5bc7;
        box-shadow: 0px 4px 6px 0px rgba(98, 54, 255, 0.15);
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
    }

    .text {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.6);
      line-height: 16px;
      margin-bottom: 2.2vh;
    }

    .logo {
      height: 16px;
      object-fit: contain;
      margin-bottom: 35px;
    }
  }
}
</style>
